export default "__VITE_ASSET__0LPOkeIc__"